import React from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Button, Grid, Link, Paper, Typography } from '@mui/material';
import AuthenticationStore from '@components/membership/stores/AuthenticationStore';
import BaseTextField from '@components/common/form/components/BaseTextField';
import KeyIcon from '@mui/icons-material/Key';
import EmailTwoToneIcon from '@mui/icons-material/EmailTwoTone';
import BaseLoadingButton from '@components/common/atoms/BaseLoadingButton';
import NaruckoLogoBlack from '@assets/narucko-logo-black.svg';
import { useNavigate } from 'react-router';

interface LoginProps {
    authenticationStore: AuthenticationStore
}

const Login: React.FC<LoginProps> = observer(({ authenticationStore }) => {
    const { form, isLoading, setIsLoginDrawerOpen } = authenticationStore;
    const navigate = useNavigate();
    return (
        <form>
            <Box
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"center"}
                alignItems={"center"}>
                <Box
                    component="img"
                    sx={{
                        width: { xs: 120, sm: 140, md: 150 },
                    }}
                    alt="logo"
                    src={NaruckoLogoBlack}
                />
                <Box
                    mt={4}
                    mb={2}
                    width={"100%"}
                    display={"flex"}
                    flexDirection={"column"}
                    justifyContent={"flex-start"}
                    alignItems={"flex-start"}
                    gap={3}>
                    <BaseTextField
                        field={form.$("userName")}
                        fullWidth
                        icon={<EmailTwoToneIcon />} />

                    <BaseTextField
                        field={form.$("password")}
                        fullWidth
                        icon={<KeyIcon />} />
                </Box>

                <Link
                    sx={{
                        mb: 2,
                    }}
                    variant="subtitle2"
                    color="secondary"
                    alignSelf={"flex-end"}
                    onClick={() => {
                        setIsLoginDrawerOpen(false);
                        navigate("/password-recovery")
                    }}>
                    Zaboravio sam lozinku/korisničko ime
                </Link>

                <BaseLoadingButton
                    variant="contained"
                    fullWidth
                    color='secondary'
                    type='submit'
                    isLoading={isLoading}
                    disabled={isLoading}
                    onClick={form.onSubmit}
                    size={"medium"}>
                    <Typography>Prijavi se</Typography>
                </BaseLoadingButton>


                <Typography mt={6} variant='subtitle2'>
                    Novi si na Naručku?
                </Typography>

                <Button
                    fullWidth
                    color='secondary'
                    variant='outlined'
                    onClick={() => {
                        setIsLoginDrawerOpen(false);
                        navigate("/registration");
                    }}>
                    <Typography>
                        Registriraj se
                    </Typography>
                </Button>
            </Box>
        </form>
    )
})

export default Login;